import React from "react";
import { Row, Col, Container } from "shards-react";
import PageTitle from "../common/PageTitle";
import BarChartSmall from "./barChartSmall";
import LineChartBig from "./lineChartBig";
import DoughnutChart from "./doughnutCharts";
import sessionService from "../../services/sessionService";

let data1 = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  datasets: [{
    borderWidth: 1,
    backgroundColor: "rgb(80, 215, 255)",
    data: [2, 3, 2, 3, 3, 4, 4, 5, 3, 2, 3, 2, 1]
  }]
}
let data2 = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  datasets: [{
    borderWidth: 1,
    backgroundColor: "rgb(128, 120, 253)",
    data: [2, 3, 2, 3, 3, 4, 4, 5, 3, 2, 3, 2, 1]
  }]
}
let data3 = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  datasets: [{
    borderWidth: 1,
    backgroundColor: "rgb(50, 246, 149)",
    data: [2, 3, 2, 3, 3, 4, 4, 5, 3, 2, 3, 2, 1]
  }]
}

let data4 = {

  labels: Array.from(new Array(30), (_, i) => (i === 0 ? 1 : i)),
  datasets: [
    {
      label: "Current Month",
      fill: "start",
      data: [
        500,
        800,
        320,
        180,
        240,
        320,
        230,
        650,
        590,
        1200,
        750,
        940,
        1420,
        1200,
        960,
        1450,
        1820,
        2800,
        2102,
        1920,
        3920,
        3202,
        3140,
        2800,
        3200,
        3200,
        3400,
        2910,
        3100,
        4250
      ],
      backgroundColor: "rgba(0,123,255,0.1)",
      borderColor: "rgba(0,123,255,1)",
      pointBackgroundColor: "#ffffff",
      pointHoverBackgroundColor: "rgb(0,123,255)",
      borderWidth: 1.5,
      pointRadius: 0,
      pointHoverRadius: 3
    },
    {
      label: "Past Month",
      fill: "start",
      data: [
        380,
        430,
        120,
        230,
        410,
        740,
        472,
        219,
        391,
        229,
        400,
        203,
        301,
        380,
        291,
        620,
        700,
        300,
        630,
        402,
        320,
        380,
        289,
        410,
        300,
        530,
        630,
        720,
        780,
        1200
      ],
      backgroundColor: "rgba(255,65,105,0.1)",
      borderColor: "rgba(255,65,105,1)",
      pointBackgroundColor: "#ffffff",
      pointHoverBackgroundColor: "rgba(255,65,105,1)",
      borderDash: [3, 3],
      borderWidth: 1,
      pointRadius: 0,
      pointHoverRadius: 2,
      pointBorderColor: "rgba(255,65,105,1)"
    }
  ]

}

let data5 = {
  labels: [
    'Desktop',
    'Tablet',
    'Mobile'
  ],
  datasets: [
    {
      borderWidth: 0,
      data: [300, 50, 100],
      backgroundColor: [
        '#55D8FE',
        '#A3A0FB',
        '#FFDA83'
      ],
      hoverBackgroundColor: [
        '#55D8FE',
        '#A3A0FB',
        '#FFDA83'
      ]
    }
  ]
};

export default class Charts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: sessionService.getUserUsername()
    }
  }

  render() {
    return (
      <Container>
        <Row noGutters className="page-header py-4">
          <PageTitle title={`Welcome back, ${this.state.username}.`} subtitle="Dashboard" className="text-sm-left mb-3" />
        </Row>
        <Row>
          <Col md="6" sm="12" className="mb-4 col-xl">
            <BarChartSmall data={data1} title="Users" total="2542" percentage="13.8" increase={false} />
          </Col>

          <Col md="6" sm="12" className="mb-4 col-xl">
            <BarChartSmall data={data2} title="SIP count" total="2453" percentage="13.8" increase={true} />
          </Col>
          <Col md="6" sm="12" className="mb-4 col-xl">
            <BarChartSmall data={data3} title="Outbound count" total="12000" percentage="13.8" increase={false} />
          </Col>
        </Row>
        <Row>
          <Col xl="7" lg="12" md="12" sm="12" className="mb-4 col-lg">
            <LineChartBig data={data4} title="Users" total="1222" percentage="22" increase="true" />
          </Col>
          <Col xl="5" lg="12" md="12" sm="12" className="mb-4  col-lg">
            <DoughnutChart data={data5} title="Devices" total="1222" percentage="22" increase="true" />
          </Col>
        </Row>
      </Container>


    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashChartsComponent/charts.js